export const en = {
    'phrases-cell-title': 'Keywords',
    'shows-cell-title': 'Impression count'
};
